import { CartView } from '../views/Cart/cart.view';
import { ConfirmationFreeView } from '../views/ConfirmationFree/ConfirmationFree.view';
import { PaymentErrorView } from '../views/PaymentError/paymentError.view';
import { PaymentMethodView } from '../views/PaymentMethod/paymentMethod.view';
import { PaymentSuccessView } from '../views/PaymentSuccess/paymentSuccess.view';
import { RouteType, type } from './Router';
import { Routes } from './types';

export const purchasesRoutes: RouteType[] = [
  {
    id: 'cart',
    path: Routes.Cart,
    titleKey: 'pageTitles.cart',
    type: type.SECURED,
    component: CartView,
  },
  {
    id: 'payment-method',
    path: Routes.PaymentMethod,
    titleKey: 'pageTitles.paymentMethod',
    type: type.SECURED,
    component: PaymentMethodView,
  },
  {
    id: 'payment-success',
    path: Routes.PaymentSuccess,
    titleKey: 'pageTitles.paymentSuccess',
    type: type.SECURED,
    component: PaymentSuccessView,
  },
  {
    id: 'payment-error',
    path: Routes.PaymentError,
    titleKey: 'pageTitles.paymentSuccess',
    type: type.SECURED,
    component: PaymentErrorView,
  },
  {
    id: 'confirmation-free',
    path: Routes.ConfirmationFree,
    titleKey: 'pageTitles.confirmationFree',
    type: type.PUBLIC,
    component: ConfirmationFreeView,
  },
];
